
  import { Component, Vue, Prop } from "vue-property-decorator";
  import LzModal from "@/components/Modal.vue";
  import LzButton from "@/components/Button.vue";
  import website from "../../api/website";
  import { namespace } from "vuex-class";
  const auth = namespace("auth");

  type TTemplate = {
    id: string;
    image: string;
    key: string;
  };

  @Component({
    components: { LzButton, LzModal }
  })
  export default class ChooseTemplate extends Vue {
    showModal = false;
    templates: TTemplate[] = [];
    modalImage = "";
    modernTemplateId = "";

    @Prop({ required: true })
    protected readonly chosenTemplateId!: string;

    @auth.State("websiteId")
    websiteId!: string;

    async mounted() {
      const data = await website.templates.getAll();
      this.templates = data;
      this.modernTemplateId = data.find(item => item.key === "modern").id;
    }

    openModal(clickedTemplateId = "") {
      this.showModal = true;

      this.modalImage =
        this.templates.find(({ id }) => id === clickedTemplateId)?.image || "";
    }

    closeModal() {
      this.showModal = false;
    }

    get theme() {
      return (templateId: TTemplate["id"]) =>
        templateId === this.chosenTemplateId
          ? this.chosenTemplateTheme
          : this.fallBackTheme;
    }

    get chosenTemplateTheme() {
      return {
        "--template-footer-background-color": "#0093A7",
        "--svg-icon-color": "white",
        "--template-text-color": "white"
      };
    }

    get fallBackTheme() {
      return {
        "--template-footer-background-color": "#ffffff",
        "--svg-icon-color": "#2c3e50",
        "--template-text-color": "black"
      };
    }

    get computedTemplates() {
      return this.templates?.map((template, i) => ({
        id: template.id,
        style:
          template.id === this.chosenTemplateId
            ? this.chosenTemplateTheme
            : this.fallBackTheme,
        backgroundImage: { backgroundImage: `url(${template.image})` },
        text: this.$t(`web.public.chooseTemplate.template${i + 1}`),
        key: template.key
      }));
    }

    isTemplateDisabled(templateId: string): boolean {
      return templateId !== this.modernTemplateId;
    }

    handleChooseTemplate(key: string) {
      const payload = {
        websiteId: this.websiteId,
        templateName: key
      };
      website.templates
        .changeTemplate(payload)
        .then(response => {
          /* console.log("Template changed successfully:", response); */
        })
        .catch(error => {
          /* console.error("Error changing template:", error); */
        });
    }
  }
